import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SensorIframe from '../../components/SensorIframe';
import ShowLabelsCheckbox from '../../components/ShowLabelsCheckbox';
import SensorSelect from '../../components/SensorSelect';
import CompanySelector from '../../components/CompanySelector';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import GroupSelector from '../../components/GroupSelector';

const YearlyFilterBox = ({
    sensorLabel,
    isSmallScreen,
    showLabels,
    onShowLabelsChange,
    sensorOptions,
    selectedSensor,
    handleSensorChange,
    companyOptions,
    selectedCompany,
    handleCompanyChange,
    isSuperAdmin,
    selectedGroup,
    handleGroupChange,
    groupOptions,
}) => {
    const theme = useTheme();

    const [open, setOpen] = useState(!isSmallScreen);
    const toggleOpen = () => setOpen(!open);

    const hasGroups = Array.isArray(groupOptions) && groupOptions.length > 0;

    return (
        <Box backgroundColor={(theme) => theme.palette.background.paper} borderRadius="15px" overflow="hidden" p="0.5rem" boxShadow="0 4px 20px rgba(0,0,0,0.1)">
            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ px: 1, py: 1 }}>
                <Box display="flex" gap="1rem">
                    <Typography
                        variant="h3"
                        component="div"
                        sx={{
                            color: (theme) => theme.palette.text.white,
                            fontWeight: 'bold',
                        }}
                    >
                        DEVICE
                    </Typography>

                    <ChangeCircleIcon sx={{ mt: '-2px' }} fontSize="large" />
                </Box>

                <IconButton
                    onClick={toggleOpen}
                    sx={{
                        color: '#000',
                        outline: 'none',
                        boxShadow: 'none',
                        '&:focus': {
                            outline: 'none',
                            boxShadow: 'none',
                        },
                        '&:active': {
                            outline: 'none',
                            boxShadow: 'none',
                        },
                    }}
                >
                    {open ? <ExpandLessIcon sx={{ color: theme.palette.text.white }} /> : <ExpandMoreIcon sx={{ color: theme.palette.text.white }} />}
                </IconButton>
            </Box>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box>
                    <SensorIframe sensorLabel={sensorLabel} isSmallScreen={isSmallScreen} />

                    {isSuperAdmin && (
                        <Box m={1}>
                            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, mt: 4 }}>
                                CHANGE COMPANY
                            </Typography>
                            <CompanySelector selectedCompany={selectedCompany} handleCompanyChange={handleCompanyChange} companyOptions={companyOptions} />
                        </Box>
                    )}

                    {hasGroups && (
                        <Box m={1}>
                            <Typography
                                variant="h5"
                                fontWeight="bold"
                                sx={{
                                    mb: 2,
                                    mt: 4,
                                    color: theme.palette.text.white,
                                }}
                            >
                                CHANGE GROUP
                            </Typography>
                            <GroupSelector selectedGroup={selectedGroup} handleGroupChange={handleGroupChange} groupOptions={groupOptions} />
                        </Box>
                    )}

                    <Box m={1}>
                        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, mt: 4 }}>
                            CHANGE DEVICE
                        </Typography>
                        <SensorSelect sensorOptions={sensorOptions} selectedSensor={selectedSensor} handleSensorChange={handleSensorChange} isSmallScreen={isSmallScreen} />
                    </Box>

                    <Box mb={2} mt={4} ml={1}>
                        <ShowLabelsCheckbox showLabels={showLabels} onChange={onShowLabelsChange} isSmallScreen={isSmallScreen} />
                    </Box>
                </Box>
            </Collapse>
        </Box>
    );
};

export default YearlyFilterBox;
